import { Trans, useTranslation } from "react-i18next";
import { ButtonV2 } from "#src/commonV2/Button";
import { ModalV2 } from "#src/commonV2/modal/ModalV2";

type IUseEmailFromDomainModalProps = {
  open: boolean;
  callingAPI: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const UseEmailFromDomainModal = ({
  open,
  callingAPI,
  onClose,
  onConfirm,
}: IUseEmailFromDomainModalProps) => {
  const { t } = useTranslation("workspace", {
    keyPrefix: "security.useEmailFromDomainModal",
  });

  return (
    <ModalV2 open={open} onChangeOpen={onClose}>
      <span className="text-lg font-semibold text-gray-v2-900">
        {t("title")}
      </span>
      <div className="flex flex-col gap-4 text-md text-gray-v2-600">
        {/* Desc */}
        <p>{t("desc")}</p>
        <p>
          <Trans
            t={t}
            i18nKey={"note"}
            components={{
              span: <span className="text-md font-semibold text-gray-v2-900" />,
            }}
          />
        </p>
        {/* Desc end */}
      </div>
      {/* Footer */}
      <div className="flex gap-2 justify-end">
        <ButtonV2
          variant="secondary"
          size="lg"
          color="gray"
          disabled={callingAPI}
          onClick={onClose}
        >
          <p>{t("button.cancel")}</p>
        </ButtonV2>

        <ButtonV2
          variant="primary"
          size="lg"
          pending={callingAPI}
          onClick={onConfirm}
        >
          <p>{t("button.confirm")}</p>
        </ButtonV2>
      </div>
      {/* Footer end */}
    </ModalV2>
  );
};
